export default {
  SUPER_USER: 'SUPER USER',
  AUTO_HOLDS_MANAGER: 'AUTO HOLDS ADMIN',
  ACCOUNTING: 'ACCOUNTING',
  TEMP_UNHOLD_REQUESTOR: 'TEMP UNHOLD REQUESTOR',
  APPROVER: 'APPROVER',
};
